<template>
  <div>
    <toptitle :title1="titlework" />
    <div class="edumessage">
      <van-row class="message-bg">
        <div class="message-bg1"></div>
        <van-col span="4">
          <p>姓名</p>
        </van-col>
        <van-col span="5">
          <p>职位</p>
        </van-col>
        <van-col span="4">
          <p>部门</p>
        </van-col>
        <van-col span="4">
          <p>绩效等级</p>
        </van-col>
        <van-col span="7">
          <p>日期</p>
        </van-col>
      </van-row>
      <van-empty v-show="emptyShow"
                 description="暂无数据" />
      <div>

        <van-row class="edumessage-bt"
                 v-for="(item,index) in userAchieveData"
                 :key="index">
          <van-col span="4">{{item.NAME}}</van-col>
          <van-col span="5">{{item.POSN_DESCR}}</van-col>
          <van-col span="4">{{item.DEPT_DESCR}}</van-col>
          <van-col span="4">{{item.LEVEL}}</van-col>
          <van-col span="7">{{item.DATE}}</van-col>
        </van-row>

      </div>

      <loading-show :isLoadindShow="loading"></loading-show>
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'
import LoadingShow from '../components/loading'
import toptitle from '../components/toptitle'
import { detailformanceDataApi } from '../request/api'
export default {
  components: {
    toptitle,
    LoadingShow,
  },
  data() {
    return {
      titlework: '团队绩效详情',
      emplId: this.$route.query.EMPLID,
      loading: false,
      emptyShow: false,
      userAchieveData: [],
    }
  },
  mounted() {
    this.getAchievementData()
  },
  methods: {
    getAchievementData() {
      this.loading = true
      let params = {
        EMPLID: this.emplId,
      }
      detailformanceDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.userAchieveData = res.DATA
          if (this.userAchieveData == 0) {
            this.emptyShow = true
          } else {
            this.emptyShow = false
          }
          this.loading = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.edumessage {
  border: 1px solid #f6f7f7;
  background: #fff;
  .edumessage-bt {
    font-size: 12px;
    line-height: 34px;
    text-align: center;
  }
}
.message-bg {
  .message-bg1 {
    width: 100%;
    height: 5px;
    background: #007fc6;
  }
  border: 1px solid #f6f7f7;
  border-radius: 3px;
  overflow: hidden;
  p {
    width: 100%;
    background: #f8f5f4;
    height: 35px;
    line-height: 35px;
    color: black;
    font-size: 12px;
    font-weight: 550;
    text-align: center;
  }
  section {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #343434;
    text-align: center;
  }
}
</style>